/**
 * @param {Object} props
 * @param {String} color - the colour for the chevron
 * @param {String} direction - the direction for the chevron
 * @returns an chevron
 */
const NaChevron = ({
  color = '#000000',
  direction = 's',
  width = '21',
  height = '14',
}) => {
  const getRotation = direction => {
    const LcDirection = direction.toLowerCase();

    if (LcDirection == 'n') {
      return 180;
    } else if (LcDirection == 'e') {
      return 270;
    } else if (LcDirection == 's') {
      return 0;
    } else if (LcDirection == 'w') {
      return 90;
    }
    return 0;
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 14"
      style={{ transform: `rotate(${getRotation(direction)}deg)` }}>
      <g data-name="Group 15504">
        <path
          d="M21.273 2.94 18.442.102l-5.629 5.629-2.159 2.236L2.729 0 .003 3.015l10.651 10.617Z"
          data-name="Path 9899"
          fill={color}
        />
      </g>
    </svg>
  );
};
export default NaChevron;
